<template>
  <div class="clearfix">
      <a-upload
        action="#"
        :customRequest="customRequest"
        :multiple="true"
        :file-list="fileList"
        :remove="removeFile"
        :disabled="disableBool"
    >
        <a-button> <a-icon type="upload" /> 上传 </a-button>
    </a-upload>

  </div>
</template>

<script>
export default {
   data(){
     return{
        loading:false,
     }
   },
   props:{
      fileList:{
          type:Array
      },
      disableBool:{
          type:Boolean,
          default:false
      }
   },
   methods:{
      customRequest(info){
          let formdata=new FormData();
          formdata.append("file",info.file);
          this.loading = true;
          this.$https.post('/file/upload',formdata).then(res=>{
             this.loading = false;
             if(res.code == 200){
                  let obj = {
                      uid: info.file.uid,
                      name: res.data.name,
                      status: 'done',
                      url:res.data.url,
                  }
                  this.fileList.push(obj);
                  this.$emit('getFile',this.fileList)
             }
          }).catch(error=>{
            this.loading = false;
             this.$error({content:'上传失败'});
          })
      },
      removeFile(file){
           let arr = [];
           this.fileList.forEach(item=>{
              if(item.url != file.url){
                  arr.push(item)
              }
           })
           this.$emit('changeFile',arr)
      },


      beforeUpload(file) {

      },
   }
}
</script>

<style>

</style>